export default {
	expdigDiagnose: {
		deviceModel: 'Modelo de Dispositivo',
                waveSpectrum: 'Gráfico de forma de onda y espectro',
                eigenvalue: 'Valores característicos',
                multiWave: 'Múltiples formas de onda',
                timeDomainTrend: 'Multitendencia de indicadores en el dominio del tiempo',
		multiSpectrum: 'Multi-Espectro',
                envelopeDemod: 'Demodulación de envolvente',
                orderAnalysis: 'Análisis de órdenes',
                orderEnvelope: 'Envolvente de órdenes',
		waterfall: 'Diagrama de Cascada',
		cepstrum: 'Cepstrum',
                crossSpectrumPhase: 'Fase del espectro cruzado',
                multiSensorIndicator: 'Indicadores de múltiples puntos',
                axisOrbit: 'Órbita del eje',
		component: 'Componente',
		healthLifePredict: 'Predicción de Salud y Vida Útil',
                singleValueBar: 'Gráfico de barras de valor único',
		bodePlot: 'Diagrama de Bode',
                multiParameter: 'Análisis multiparámetro',
                runStatus: 'Diagrama de estado operativo',
		indicatorDiagram: 'Diagrama Indicador',
                pistonRodTrajectory: 'Gráfico de trayectoria del vástago del pistón',
                stressMonitor: 'Monitoreo de esfuerzos',
		impactDiag: 'Diagnóstico de Impacto',
                vibrationMonitor: 'Monitoreo de vibración',
                pistonRodSettlement: 'Monitoreo del asentamiento/desviación del vástago del pistón',
		historyCompare: 'Comparación Histórica',
                otherParameter: 'Otros parámetros',
                instantSpeedMonitor: 'Monitoreo de velocidad instantánea',
		torsionalVibration: 'Vibración Torsional',
                orderAnalysisICE: 'Análisis de órdenes (motor de combustión interna)',
                orderEnvelopeICE: 'Envolvente de órdenes (motor de combustión interna)',
		dcsTrend: 'Tendencia de Proceso',
                // Opciones rápidas
		last1Day: 'Último 1 Día',
		last3Days: 'Últimos 3 Días',
		last7Days: 'Últimos 7 Días',
		last1Month: 'Último 1 Mes',
		last3Months: 'Últimos 3 Meses',
                // Menú de herramientas
                trend: 'Gráfico de tendencia',
		wave: 'Onda',
		spectrum: 'Espectro',
		amplitudeSpeed: 'Amplitud-Velocidad',
		phaseSpeed: 'Fase-Velocidad',
		orderWave: 'Onda de Orden',
		orderSpectrum: 'Espectro de Orden',
                envSpectrum: 'Espectro de envolvente',
                multiParameterAnalysis: 'Análisis multiparámetro',
		phaseDiffSpectrum: 'Espectro de Diferencia de Fase',
		xAxisWave: 'Onda del Sensor Eje X',
		yAxisWave: 'Onda del Sensor Eje Y',
		dynamicPressureTrend: 'Tendencia de Presión Dinámica',
                // Botones de herramientas
		mark: 'Marcar',
		export: 'Exportar',
		modelAnnotation: 'Anotación de Modelo',
		dualCursor: 'Cursor Dual',
		sideFrequency: 'Frecuencia Lateral',
		filter: 'Filtro',
		abnormalAnnotation: 'Anotación Anormal',
		peakSpectrumTable: 'Tabla de Espectro de Picos',
		frequencyBand: 'Banda de Frecuencia',
		multipleFrequency: 'Frecuencia Múltiple',
		rotationFrequency: 'Velocidad de Rotación',
		characteristicFrequency: 'Frecuencia Característica',
		// otros
		gridLayout: 'Diseño de Cuadrícula',
		averageAmplitude: 'Amplitud Promedio',
		clearanceFactor: 'Factor de Holgura',
		crestFactor: 'Factor de Cresta',
		impulseFactor: 'Factor de Impulso',
		kurtosisFactor: 'Factor de Curtosis',
		maximum: 'Máximo',
		mean: 'Media',
		minimum: 'Mínimo',
		peak: 'Pico',
		peakToPeak: 'Pico a Pico',
		rms: 'RMS',
		rootAmplitude: 'Amplitud de Raíz',
		shapeFactor: 'Factor de Forma',
		skewnessFactor: 'Factor de Asimetría',
		// trendRef component
		time: 'Tiempo',
		peakValue: 'Valor Pico',
		rmsValue: 'Valor RMS',
		// com-list component
		lowFrequency: 'Baja Frecuencia',
		highFrequency: 'Alta Frecuencia',
		longWaveform: 'Onda Larga',
		selectAxial: 'Seleccione dirección axial',
		selectedPoints: '{count} puntos de medición seleccionados',
		noSelect: 'No Seleccionado',
		xAxisPoint: 'Sensor Eje X',
		yAxisPoint: 'Sensor Eje Y',
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		separator: ' - ',
		selectIndicator: 'Seleccionar Indicador',
		multiChart: 'Multi-Gráfico',
		singleChart: 'Gráfico Único',
		resetChart: 'Restablecer Gráfico',
		basicInfo: 'Información Básica',
		deviceOverview: 'Resumen del Dispositivo',
		deviceNumber: 'Número de Dispositivo',
		deviceName: 'Nombre del Dispositivo',
		deviceType: 'Tipo de Dispositivo',
		productionArea: 'Área de Producción',
		deviceStatus: 'Estado del Dispositivo',
		health: 'Salud',
		alarmLevel: 'Nivel de Alarma',
		runtime: 'Tiempo de Funcionamiento',
		alarmTotal: 'Total de Alarmas',
		lifePrediction: 'Predicción de Vida Útil',
		month: 'Mes',
		hour: 'h',
		running: 'Funcionando',
		stop: 'Detenido',
		offline: 'Desconectado',
		unknown: 'Desconocido',
		normal: 'Normal',
		general: 'General',
		medium: 'Medio',
		severe: 'Severo',
		exportWaveButton: 'Exportar forma de onda por rango de tiempo'
	},
	treeCom: {
		searchPlaceholder: 'Ingrese palabra clave del dispositivo',
		expandLevel: '{level}',
		levelList: ['Nivel 1', 'Nivel 2', 'Nivel 3', 'Nivel 4'],
		allDevices: 'Todos los Dispositivos',
		online: 'En Línea',
		stop: 'Detenido',
		offline: 'Desconectado'
	},
	fluidsChart: {
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		resetChart: 'Restablecer Gráfico'
	},
	comList: {
		pistonRodSettlement: 'Sensor de Asentamiento/Desviación de Biela',
		cylinderSelection: 'Selección de Cilindro'
	},
	collChart: {
		rawWave: 'Onda Cruda',
		spectrum: 'Espectro',
		waveform: 'Forma de Onda',
		spectrumChart: 'Espectro',
		trend: 'Tendencia',
		samplingFreq: 'Frecuencia de Muestreo',
		rpm: 'RPM',
		generalAlarm: 'Alarma General',
		mediumAlarm: 'Alarma Media',
		severeAlarm: 'Alarma Severa',
		alarm: 'Alarma',
		exportDialogTitle: 'Exportar datos de forma de onda por rango de tiempo',
		timeRange: 'Rango de tiempo',
		rangeSeparator: 'hasta',
		startTime: 'Hora de inicio',
		endTime: 'Hora de fin',
		collectType: 'Tipo de recopilación',
		highFrequencyOption: 'Alta frecuencia (02)',
		lowFrequencyOption: 'Baja frecuencia (01)',
		longWaveformOption: 'Onda larga (04)',
		exportTips: 'Se pueden exportar hasta 3000 puntos de tiempo de muestreo a la vez. Si se excede, reduzca el rango de tiempo y exporte en lotes. Volúmenes grandes de datos pueden tardar mucho, por favor espere con paciencia.',
		cancel: 'Cancelar',
		confirmExport: 'Confirmar exportación',
		timeRangeInvalid: 'Rango de tiempo no válido',
		selectTimeRange: 'Por favor seleccione un rango de tiempo',
		exportFailed: 'Error en la exportación',
		exportSuccess: 'Exportación exitosa',
		exportFailedRetry: 'Error en la exportación, inténtelo de nuevo'
	},
	barChart: {
		noChartData: 'Sin Datos de Gráfico',
		status: 'Estado',
		normal: 'Normal',
		warning: 'Advertencia',
		danger: 'Peligro'
	},
	bodeChart: {
		phase: 'Fase',
		amplitude: 'Amplitud',
		rawData: 'Datos Crudos',
		tongpin: 'General',
		oneXFreq: 'Frecuencia 1X',
		twoXFreq: 'Frecuencia 2X',
		halfXFreq: 'Frecuencia 0.5X'
	},
	crossChart: {
		phaseDiffSpectrum: 'Espectro de Diferencia de Fase',
		amplitudeSpectrum: 'Espectro de Amplitud',
		samplingFreq: 'Frecuencia de Muestreo',
		crossPoint: 'Punto Cruzado'
	},
	crewSidebar: {
		deviceName: 'Nombre del Dispositivo',
		sensorSelection: 'Selección de Sensor',
		compareType: 'Tipo de Comparación',
		samePoint: 'Mismo Punto',
		diffPoint: 'Puntos Diferentes'
	},
	diagnoseSidebar: {
		deviceName: 'Nombre del Dispositivo',
		sensorSelection: 'Selección de Sensor',
		pistonRodTrajectory: 'Trayectoria de Biela'
	},
	eigTags: {
		selectAll: 'Seleccionar Todo'
	},
	eigMultSingle: {
                featureValue: 'Valores característicos'
	},
	eigMultsSingle: {
		multiPointIndicator: 'Indicador de Multi-Punto'
	},
	fludisTrends: {
		indicatorDataTable: 'Tabla de Estadísticas de Datos del Indicador',
		time: 'Tiempo',
		export: 'Exportar'
	},
	envCom: {
		envelopeSpectrum: 'Espectro de Sobretensión',
		spectrum: 'Espectro',
		samplingFreq: 'Frecuencia de Muestreo',
		demodFreqBand: 'Banda de Frecuencia de Demodulación'
	},
	filterCom: {
		filterConfig: 'Configuración de Filtro',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		filter: 'Filtro'
	},
	historyCompare: {
		historyTrend: 'Gráfico de Tendencia Histórica',
		historyWave: 'Gráfico de Onda Histórica',
		mark: 'Marcar',
		export: 'Exportar',
		noData: 'Sin Datos',
		second: 'Segundo',
		time: 'Tiempo'
	},
	healthLife: {
		deviceHealth: 'Salud del Dispositivo',
		remainingLife: 'Predicción de Vida Útil Restante',
		healthTrendAnalysis: 'Análisis de Tendencia de Salud del Dispositivo',
		lifePredictionTrend: 'Tendencia de Predicción de Vida Útil Restante',
		last1Month: 'Último 1 Mes',
		last3Months: 'Últimos 3 Meses',
		last6Months: 'Últimos 6 Meses',
		last1Year: 'Último 1 Año',
		refresh: 'Actualizar',
		healthDetailAnalysis: 'Análisis Detallado de Salud',
		impactFactorAnalysis: 'Análisis de Factores de Impacto',
		factor: 'Factor',
		weight: 'Peso',
		currentValue: 'Valor Actual',
		normalRange: 'Rango Normal',
		impactDegree: 'Grado de Impacto',
		maintenanceSuggestions: 'Sugerencias de Mantenimiento',
		excellent: 'Excelente',
		good: 'Bueno',
		normal: 'Normal',
		poor: 'Deficiente',
		sufficient: 'Suficiente',
		needAttention: 'Necesita Atención',
		needReplace: 'Necesita Reemplazo',
		rise: 'Aumento',
		drop: 'Descenso',
		stable: 'Estable',
		healthDataUpdated: 'Datos de salud actualizados',
		lifeDataUpdated: 'Datos de predicción de vida útil actualizados',
		excellentLine: 'Línea Excelente',
		goodLine: 'Línea Buena',
		warningLine: 'Línea de Advertencia',
		maxValue: 'Máximo',
		minValue: 'Mínimo',
		remainingLifePrediction: 'Predicción de Vida Útil Restante',
		predictedValue: '(Predicho)',
		month: 'Mes'
	},
	multChart: {
		rawWave: 'Onda Cruda',
		spectrum: 'Espectro',
		cepstrum: 'Cepstrum',
		crossPhase: 'Fase Cruzada',
		waveform: 'Forma de Onda',
		samplingFreq: 'Frecuencia de Muestreo'
	},
	indicatorDiagram: {
		dynamicPressureTrend: 'Gráfico de Tendencia de Presión Dinámica',
		waveformChart: 'Gráfico de Forma de Onda',
		time: 'Tiempo',
		noData: 'Sin Datos',
		exhaustShadow: 'Sombra de Escape',
		intakeShadow: 'Sombra de Admisión',
		exhaustShadowArea: 'Área de Sombra de Escape',
		intakeShadowArea: 'Área de Sombra de Admisión'
	},
	indicatorSidebar: {
		deviceName: 'Nombre del Dispositivo',
		compareType: 'Tipo de Comparación',
		sameSidePoint: 'Mismo Punto Lateral',
		diffPoint: 'Puntos Diferentes',
		sensorSelection: 'Selección de Sensor',
		diagramSelection: 'Selección de Diagrama'
	},
	multParameter: {
		generalAlarm: 'Alarma General',
		mediumAlarm: 'Alarma Media',
		severeAlarm: 'Alarma Severa',
		alarm: 'Alarma',
		pistonRodSettlement: 'Asentamiento de Biela (um)',
		dynamicPressure: 'Presión Dinámica (kPa)',
		vibrationAcceleration: 'Aceleración de Vibración (m/s2)',
		multiParameterAnalysis: 'Análisis Multi-Parámetro (Ángulo/Valor)',
		angle: 'Ángulo (°)',
		orderWave: 'Onda de Orden',
		orderSpectrum: 'Espectro de Orden',
		samplingFreq: 'Frecuencia de Muestreo',
		rpm: 'RPM',
		turns: 'Vueltas(n)'
	},
	multTrends: {
		indicatorDataTable: 'Tabla de Estadísticas de Datos del Indicador',
		time: 'Tiempo',
		export: 'Exportar',
		timeDomainIndicatorMultiTrend: 'Multi-Tendencia de Indicador de Dominio Temporal'
	},
	orderAnalysis: {
		trendChart: 'Gráfico de Tendencia',
		orderWave: 'Onda de Orden',
		orderSpectrum: 'Espectro de Orden',
		mark: 'Marcar',
		export: 'Exportar',
		time: 'Tiempo',
		turns: 'Vueltas(n)',
		waveform: 'Forma de Onda',
		spectrum: 'Espectro',
		trend: 'Tendencia',
		generalAlarm: 'Alarma General',
		mediumAlarm: 'Alarma Media',
		severeAlarm: 'Alarma Severa',
		alarm: 'Alarma',
		samplingFreq: 'Frecuencia de Muestreo',
		rpm: 'RPM'
	},
	orderEnvelope: {
		trendChart: 'Gráfico de Tendencia',
                orderEnvelopeWave: 'Onda de envolvente de órdenes',
                orderEnvelopeSpectrum: 'Espectro de envolvente de órdenes',
		mark: 'Marcar',
		export: 'Exportar',
		time: 'Tiempo',
		turns: 'Vueltas(n)',
		waveform: 'Forma de Onda',
		spectrum: 'Espectro',
		trend: 'Tendencia',
		generalAlarm: 'Alarma General',
		mediumAlarm: 'Alarma Media',
		severeAlarm: 'Alarma Severa',
		alarm: 'Alarma',
		samplingFreq: 'Frecuencia de Muestreo',
		rpm: 'RPM'
	},
	otherParameters: {
		otherParameterTrend: 'Gráfico de Tendencia de Otro Parámetro',
		unknownPoint: 'Punto Desconocido',
		trendChart: 'Gráfico de Tendencia'
	}
}
